export default {
    ENTORPECENTES: 1,
    PSICOTROPICOS: 2,
    CONTROLE_ESPECIAL: 3,
    IMUNOSSUPRESSORES: 4,
    ANTI_RETROVIRAIS: 5,
    TALIDOMIDA: 6,
    ANABOLIZANTE: 7,
    ANTIMICROBIANOS: 8,
}